import React, { useEffect, useState } from "react";
import TabNav from "../../components/TabNav";

import "./userRegister.css";
import MainLayout from "layouts/MainLayout";
import { Complaints } from "types";
import { fetchComplaint } from "services/prosecutorDecipilineService";
import { DateView } from "utils/helper";

const tabs = [
  "All",
  "Pending",
  "Under Investigation",
  "Prosecutor Decision",
  "On Litigation",
  "Council Decision",
  "Out of Jurisdiction",
  "Case Closed",
  "Draft Charge",
];




const UserRegister: React.FC = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
const [complaints, setComplaints] = useState<Complaints[]>([]);
useEffect(() => {
  fetchComplaint().then(setComplaints).catch((error) => {

        console.log(error.message); // Handle error here, e.g., show a notification or alert
      });
}, []);
  return (
    <MainLayout>
      <div className="userRegistration max-w-screen-lg">
        <div className="user-title">
          <span className="text-2xl font-semibold text-gray-700">
            ⚖ User Registration
          </span>
        </div>

        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        {activeTab === "All" ? (
          <div className="overflow-hidden bg-white shadow rounded-xl w-full">
            <table className="w-full text-sm border-collapse">
              <thead className="text-white bg-black">
                <tr>
                  <th className="p-3 text-left">Accused Advocate</th>
                  <th className="p-3 text-left">Assigned To</th>
                  <th className="p-3 text-left">Applied Date</th>
                  <th className="p-3 text-left">Status</th>
                  <th className="p-3 text-left">Phone Number</th>
                  <th className="p-3 text-left">Assign Prosecutor</th>
                </tr>
              </thead>
              <tbody>
                {/* Example row, replace with dynamic data */}
                {complaints.map((complaint, index) => (
                  <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                    <td className="p-3">{complaint.accused_prosecutor_name}</td>
                    <td className="p-3">{DateView(complaint.assigned_date)}</td>
                    <td className="p-3">{complaint.offence_description}</td>
                    <td className="p-3">{complaint.status}</td>
                    <td className="p-3">{complaint.offence_type}</td>
                    <td className="p-3">
                      <button className="px-4 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600">
                        Assign
                      </button>
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-100">
                  <td className="p-3">John Doe</td>
                  <td className="p-3">Jane Smith</td>
                  <td className="p-3">2023-10-01</td>
                  <td className="p-3">Pending</td>
                  <td className="p-3">+1234567890</td>
                  <td className="p-3">
                    <button className="px-4 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600">
                      Assign
                    </button>
                  </td>
                </tr>
                <tr>
                  <td colSpan={6} className="p-4 text-center text-gray-500">
                    No data available.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : activeTab === "Pending" ? (
          <p>Pending </p>
        ) : activeTab === "Under Investigation" ? (
          <p>under investigation </p>
        ) : activeTab === "Prosecutor Decision" ? (
          <p>Prosecutor Decision </p>
        ) : activeTab === "On Litigation" ? (
          <p>On Litigation </p>
        ) : activeTab === "Council Decision" ? (
          <p>Council Decision </p>
        ) : activeTab === "Out of Jurisdiction" ? (
          <p>Out of Jurisdiction </p>
        ) : activeTab === "Case Closed" ? (
          <p>Case Closed </p>
        ) : activeTab === "Draft Charge" ? (
          <p>Draft Charge </p>
        ) : null}
      </div>
    </MainLayout>
  );
};

export default UserRegister;
